namespace Areas.TimeEntry.Jobs {
    "use strict";

    let currentWorkOrder: any;
    let selectedWorkOrder: any;
    let selectedTaskCodeDescription: string;

    export function onInsertingNewEmployeeWorkOrder(e: any) {
        e.data.employeeId = e.component.option("EmployeeId");
        selectedWorkOrder = "";
        selectedTaskCodeDescription = "";

        currentWorkOrder = e.data;
    }   

    export function onEditingStart(e: any) {
        currentWorkOrder = e.data;
        selectedWorkOrder = e.data.displayName;
        selectedTaskCodeDescription = e.data.taskCodeDescription;
    }

    export function onRowInserted(e: any) {
        selectedWorkOrder = null;
        selectedTaskCodeDescription = null;
        currentWorkOrder = null;
    }

    export function selectWorkOrder() {
        const grid: any = $("#WorkOrderGrid").dxDataGrid("instance");

        const selectDefaultJobDialog =
            new Areas.Dialogs.SelectDefaultJob.SelectDefaultJobDialog(selectDefaultJobDialogClosing);
    }

    function selectDefaultJobDialogClosing(dialogResult: DialogResult, data:any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid: any = $("#WorkOrderGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateWorkOrdersGridRow(dataGrid, rowIndex, data);
    }

    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentWorkOrder === undefined || currentWorkOrder === null) {
            return rowIndex;
        } else if (currentWorkOrder.employeeWorkOrderId) {
            rowIndex = dataGrid.getRowIndexByKey(currentWorkOrder.employeeWorkOrderId);
        }

        return rowIndex;
    }

    function updateWorkOrdersGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "projectNumber", data.accountWorkOrder.projectNumber);
        dataGrid.cellValue(rowIndex, "projectName", data.accountWorkOrder.projectName);
        dataGrid.cellValue(rowIndex, "accountWorkOrderId", data.accountWorkOrder.accountWorkOrderId);
        dataGrid.cellValue(rowIndex, "workOrderCode", data.accountWorkOrder.workOrderCode);
        dataGrid.cellValue(rowIndex, "displayName", data.accountWorkOrder.displayName);
        dataGrid.cellValue(rowIndex, "taskCodeLk", data.taskCode.taskCodeLk);
        dataGrid.cellValue(rowIndex, "taskCodeDescription", data.taskCode.taskCodeDescription);

        selectedWorkOrder = data.accountWorkOrder.displayName;
        selectedTaskCodeDescription = data.taskCode.taskCodeDescription;

        dataGrid.repaintRows([rowIndex]);
    }

    export function editTaskCodeTemplate(cellElement, cellInfo) {
        let htmlString = `<span style='padding-left: 8px;'>${selectedTaskCodeDescription}</span>`;
        let html = $.parseHTML(htmlString);

        cellElement.append(html);
    }

    export function editWorkOrdersTemplate(cellElement, cellInfo) {
        let displayName = !selectedWorkOrder ? "Select..." : selectedWorkOrder;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${displayName}</div><div class="dx-lookup-arrow" id="workorder-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectWorkOrder);
        cellElement.append(html);
    }
}